import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useCreateCustomBenefit } from '../../createCustomBenefit/hooks/useCreateCustomBenefit';

export const useCustomBenefitActions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const snackbar = useSnackbar();
  // das umlagern
  const {
    newCustomBenefit,
    createCustomBenefit: create,
    patchCustomBenefit: patch
  } = useCreateCustomBenefit();

  const saveAsDraft = async (allowNavigation: () => void) => {
    if (!newCustomBenefit.name_de) {
      snackbar.enqueueSnackbar({
        message: t('custom:error_missing_name'),
        variant: 'error'
      });
      return false;
    }

    try {
      if (newCustomBenefit.status === 'draft') {
        if (newCustomBenefit.editingBenefitId) {
          await patch(newCustomBenefit.editingBenefitId);
        }
      } else {
        newCustomBenefit.status = 'draft';
        await create();
      }

      snackbar.enqueueSnackbar({
        message: t('custom:draft_submitted'),
        variant: 'info'
      });

      allowNavigation();
      navigate('/benefits/custom');
      return true;
    } catch {
      snackbar.enqueueSnackbar({
        message: t('custom:error_saving_draft'),
        variant: 'error'
      });
      return false;
    }
  };

  const showSaveButton = (title?: string) => {
    return (
      title === t('custom:create_custom_benefit') ||
      (title === t('custom:edit_custom_benefit') && newCustomBenefit.status === 'draft')
    );
  };

  const handleBackButtonClick = (title?: string) => {
    if (
      [t('custom:create_custom_benefit'), t('custom:edit_custom_benefit')].includes(title ?? '')
    ) {
      newCustomBenefit.backButtonClicked = true;
    }
  };

  return {
    newCustomBenefit,
    saveAsDraft,
    showSaveButton,
    handleBackButtonClick
  };
};
